import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { LabeledStat } from '@/components/common/StatCardGrid';
import type { EmployeeReportQueryOptionsFn } from '../api/attendance.api';
import type { EmployeeReportParams } from '../types/attendance.types';

export function useEmployeeReport(
  queryOptions: EmployeeReportQueryOptionsFn,
  params: EmployeeReportParams,
) {
  const { data, isLoading, error, refetch } = useQuery(queryOptions(params));

  const summaryItems = useMemo((): LabeledStat[] => {
    const summary = data?.summary;
    return [
      { key: 'total', label: 'Total', value: summary?.totalDays },
      { key: 'present', label: 'Present', value: summary?.presentDays },
      { key: 'late', label: 'Late', value: summary?.lateDays },
      { key: 'absent', label: 'Absent', value: summary?.absentDays },
      { key: 'weekend', label: 'Weekend', value: summary?.weekendDays },
    ];
  }, [data]);

  return {
    employee: data?.employee,
    attendance: data?.attendance ?? [],
    summaryItems,
    isLoading,
    error,
    refetch,
  };
}
